import { TokenRefreshLink } from "apollo-link-token-refresh";
import { env } from "../../..";
import { useAuthStore } from "@domains/auth/utils/useAuthStore";
import { createAuthorizationHeader } from "../../utils";
import { MutationRefreshAccessTokenSuccess } from "../../generated";
import { useUserStore } from "@domains/auth/utils/useUserStore";
import posthog from "posthog-js";

const refreshTokenMutation = `
  mutation refresh {
    refreshAccessToken {
      ...on MutationRefreshAccessTokenSuccess {
        data {
          accessToken
          accessTokenExpiresAt
          refreshToken
          refreshTokenExpiresAt
        }
      }
    }
  }
`;

export const tokenRefreshLink = new TokenRefreshLink({
  accessTokenField: "refreshAccessToken",
  isTokenValidOrUndefined: async () => {
    const authState = useAuthStore.getState();
    const isUndefined = authState.accessToken === null;
    const isExpired = authState.isAccessTokenExpired();
    return isUndefined || !isExpired;
  },
  fetchAccessToken: (): Promise<any> => {
    const authState = useAuthStore.getState();

    authState.setIsRefreshingToken(true);

    if (!authState.refreshToken) {
      console.log("Failed control path - No refresh token found");
      return Promise.reject();
    }

    return fetch(`${env.apiUrl}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "hypercard-authorization": env.hypercardAuthorization,
        Authorization: createAuthorizationHeader(authState.refreshToken),
      },
      body: JSON.stringify({
        query: refreshTokenMutation,
      }),
    });
  },
  handleFetch: (refreshAccessToken: MutationRefreshAccessTokenSuccess) => {
    const accessTokenData = refreshAccessToken.data;

    const newAuthState = {
      accessToken: accessTokenData.accessToken,
      refreshToken: accessTokenData.refreshToken,
      accessTokenExpiresAt: accessTokenData.accessTokenExpiresAt,
      refreshTokenExpiresAt: accessTokenData.refreshTokenExpiresAt,
      isRefreshingToken: false,
    };

    const authState = useAuthStore.getState();

    authState.setTokenState(newAuthState);
  },
  handleError: (err) => {
    const authState = useAuthStore.getState();
    const userState = useUserStore.getState();

    authState.setIsRefreshingToken(false);

    // our backend system is not designed to retry a failed refresh token. The only way to recover is to log out and log back in.
    console.error("handleError: Failed to refresh token:", err);
    userState.clear();
    posthog.reset();
    authState.signOut();
  },
});
